import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import _ from 'lodash';

const chkOptions = [
  { value: 'High', label: 'H' },
  { value: 'Medium', label: 'M' },
  { value: 'Low', label: 'L' },
];

const SearchChkPrjImpt = ({
  label,

  checkedList,
  onChangeChecked,
}) => {
  const handleChange = (item) => {
    // checkedList 에 추가/삭제하는 로직
    const updatedChkList = checkedList.includes(item)
      ? checkedList.filter((f) => f !== item)
      : [...checkedList, item];
    // onChangeChecked 호출
    onChangeChecked(updatedChkList);
  };

  return (
    <Box>
      <Typography variant="subtitle2" component="div">
        {label}
      </Typography>
      <Box>
        {chkOptions &&
          chkOptions.map((item) => {
            const findIndex = _.findIndex(
              checkedList,
              (checked) => checked === item.value,
            );
            const checked = findIndex !== -1 ? true : false;
            return (
              <FormControlLabel
                key={item.value}
                control={
                  <Checkbox
                    checked={checked}
                    name={item.value}
                    onChange={(event) => handleChange(item.value)}
                  />
                }
                label={item?.label}
              />
            );
          })}
      </Box>
    </Box>
  );
};

export default SearchChkPrjImpt;
